// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== SearchPanel – Discord-style Global Search ===== */

.search-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--bg-tertiary, #111214);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 8px;
  padding: 7px 14px;
  cursor: pointer;
  min-width: 200px;
  transition: all 0.2s;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  position: relative;
}

.search-trigger:hover {
  border-color: rgba(255,255,255,0.15);
  background: var(--bg-secondary, #18191c);
}

.search-trigger.open {
  border-color: var(--brand-primary, #b91c1c);
}

.search-trigger-icon {
  flex-shrink: 0;
  color: var(--text-muted, #64748b);
}

.search-trigger-placeholder {
  flex: 1;
  color: var(--text-muted, #64748b);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-filter-badge {
  background: var(--brand-primary, #b91c1c);
  color: white;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 6px;
}

/* Overlay */
.search-panel-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(4px);
  z-index: 99999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 60px;
}

/* Panel */
.search-panel {
  background: #111214;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px;
  width: 740px;
  max-width: 95vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0,0,0,0.7);
}

/* Input Row */
.search-input-area {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}

.search-panel-icon {
  color: var(--brand-primary, #b91c1c);
  flex-shrink: 0;
}

.search-panel-input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  font-size: 16px;
  color: #f2f3f5;
  caret-color: var(--brand-primary, #b91c1c);
}

.search-panel-input::placeholder {
  color: #64748b;
}

.search-input-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.search-filter-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.07);
  color: #94a3b8;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s;
}

.search-filter-btn:hover, .search-filter-btn.active {
  background: rgba(185,28,28,0.15);
  border-color: var(--brand-primary, #b91c1c);
  color: var(--brand-primary, #b91c1c);
}

.filter-count {
  background: var(--brand-primary, #b91c1c);
  color: white;
  border-radius: 8px;
  font-size: 10px;
  padding: 1px 5px;
}

.search-clear-btn, .search-close-btn {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.search-clear-btn:hover { color: #94a3b8; }
.search-close-btn:hover { color: #f87171; }

/* Filter Hints */
.search-hints {
  padding: 8px 18px 12px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  overflow: hidden;
}

.hints-label {
  font-size: 10px;
  font-weight: 800;
  color: #475569;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.search-hint-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.search-hint-item:hover {
  background: rgba(255,255,255,0.04);
}

.hint-icon {
  color: #475569;
  flex-shrink: 0;
}

.hint-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.hint-label {
  font-size: 13px;
  font-weight: 600;
  color: #cbd5e1;
}

.hint-sub {
  font-size: 11px;
  color: #475569;
}

/* Advanced Filters Bar */
.search-filters-bar {
  padding: 12px 18px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  overflow: hidden;
}

.filters-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-item label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-item select, .filter-item input[type="date"] {
  background: #1e1f22;
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 6px;
  color: #cbd5e1;
  padding: 6px 10px;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  min-width: 140px;
  transition: border-color 0.2s;
}

.filter-item select:focus, .filter-item input[type="date"]:focus {
  border-color: var(--brand-primary, #b91c1c);
}

.filter-checkbox label {
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  text-transform: none;
  letter-spacing: 0;
  color: #94a3b8;
  cursor: pointer;
  padding: 6px 0;
  font-weight: 500;
}

.clear-filters {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  color: #f87171;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.clear-filters:hover { text-decoration: underline; }

/* Results Area */
.search-results-area {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
}

.search-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  gap: 12px;
  color: #64748b;
  font-size: 14px;
}

.search-spinner {
  width: 28px;
  height: 28px;
  border: 2px solid rgba(185,28,28,0.2);
  border-top-color: var(--brand-primary, #b91c1c);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

.search-results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px;
  border-bottom: 1px solid rgba(255,255,255,0.04);
}

.results-count {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.results-count em {
  color: #94a3b8;
  font-style: normal;
  font-weight: 600;
}

.search-pagination {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-pagination button {
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.07);
  color: #94a3b8;
  border-radius: 5px;
  padding: 3px 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.15s;
}

.search-pagination button:hover:not(:disabled) {
  background: rgba(185,28,28,0.15);
  border-color: var(--brand-primary, #b91c1c);
  color: var(--brand-primary);
}

.search-pagination button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.search-pagination span {
  font-size: 12px;
  color: #64748b;
  min-width: 45px;
  text-align: center;
}

.search-results-list {
  padding: 8px 0;
}

.search-result-item {
  padding: 10px 18px;
  cursor: pointer;
  border-radius: 0;
  transition: background 0.15s;
  border-bottom: 1px solid rgba(255,255,255,0.03);
}

.result-channel-info {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #475569;
  margin-bottom: 6px;
  font-weight: 600;
}

.result-channel-info svg { color: #374151; }

.result-date {
  margin-left: auto;
  font-size: 10px;
  color: #374151;
  font-weight: 400;
}

.result-body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  position: relative;
}

.result-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.result-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.result-avatar-letter {
  width: 100%;
  height: 100%;
  background: var(--brand-primary, #b91c1c);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: white;
}

.result-content {
  flex: 1;
  min-width: 0;
}

.result-author {
  font-size: 13px;
  font-weight: 700;
  color: #f2f3f5;
  margin-right: 8px;
}

.result-text {
  font-size: 14px;
  color: #94a3b8;
  line-height: 1.5;
  margin: 2px 0 0;
  white-space: pre-wrap;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.search-highlight {
  background: rgba(253,224,71,0.25);
  color: #fde047;
  border-radius: 3px;
  padding: 0 1px;
  font-weight: 600;
}

.result-attachment-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #64748b;
  background: rgba(255,255,255,0.04);
  border-radius: 4px;
  padding: 2px 6px;
  margin-top: 4px;
}

.result-jump-hint {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 11px;
  color: #374151;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.2s;
}

.search-result-item:hover .result-jump-hint { opacity: 1; color: var(--brand-primary, #b91c1c); }

/* Idle & Empty States */
.search-idle, .no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #475569;
  gap: 10px;
  text-align: center;
}

.search-idle p, .no-results p {
  font-size: 15px;
  color: #64748b;
  font-weight: 500;
  margin: 0;
}

.no-results span {
  font-size: 13px;
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatHeader/SearchPanel.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;;AAE1C,iBAAiB;AACjB;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA,uBAAuB,0BAA0B,EAAE;;AAEnD,iBAAiB;AACjB;EACE,OAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,wBAAwB;AAC1B;;AAEA,8CAA8C,UAAU,EAAE,oCAAoC,EAAE;;AAEhG,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* ===== SearchPanel – Discord-style Global Search ===== */\n\n.search-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--bg-tertiary, #111214);\n  border: 1px solid rgba(255,255,255,0.07);\n  border-radius: 8px;\n  padding: 7px 14px;\n  cursor: pointer;\n  min-width: 200px;\n  transition: all 0.2s;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  position: relative;\n}\n\n.search-trigger:hover {\n  border-color: rgba(255,255,255,0.15);\n  background: var(--bg-secondary, #18191c);\n}\n\n.search-trigger.open {\n  border-color: var(--brand-primary, #b91c1c);\n}\n\n.search-trigger-icon {\n  flex-shrink: 0;\n  color: var(--text-muted, #64748b);\n}\n\n.search-trigger-placeholder {\n  flex: 1;\n  color: var(--text-muted, #64748b);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.search-filter-badge {\n  background: var(--brand-primary, #b91c1c);\n  color: white;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 1px 6px;\n}\n\n/* Overlay */\n.search-panel-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.6);\n  backdrop-filter: blur(4px);\n  z-index: 99999;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 60px;\n}\n\n/* Panel */\n.search-panel {\n  background: #111214;\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 16px;\n  width: 740px;\n  max-width: 95vw;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(0,0,0,0.7);\n}\n\n/* Input Row */\n.search-input-area {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n\n.search-panel-icon {\n  color: var(--brand-primary, #b91c1c);\n  flex-shrink: 0;\n}\n\n.search-panel-input {\n  flex: 1;\n  background: none;\n  border: none;\n  outline: none;\n  font-size: 16px;\n  color: #f2f3f5;\n  caret-color: var(--brand-primary, #b91c1c);\n}\n\n.search-panel-input::placeholder {\n  color: #64748b;\n}\n\n.search-input-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.search-filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(255,255,255,0.05);\n  border: 1px solid rgba(255,255,255,0.07);\n  color: #94a3b8;\n  padding: 5px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.search-filter-btn:hover, .search-filter-btn.active {\n  background: rgba(185,28,28,0.15);\n  border-color: var(--brand-primary, #b91c1c);\n  color: var(--brand-primary, #b91c1c);\n}\n\n.filter-count {\n  background: var(--brand-primary, #b91c1c);\n  color: white;\n  border-radius: 8px;\n  font-size: 10px;\n  padding: 1px 5px;\n}\n\n.search-clear-btn, .search-close-btn {\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.search-clear-btn:hover { color: #94a3b8; }\n.search-close-btn:hover { color: #f87171; }\n\n/* Filter Hints */\n.search-hints {\n  padding: 8px 18px 12px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n  overflow: hidden;\n}\n\n.hints-label {\n  font-size: 10px;\n  font-weight: 800;\n  color: #475569;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.search-hint-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.search-hint-item:hover {\n  background: rgba(255,255,255,0.04);\n}\n\n.hint-icon {\n  color: #475569;\n  flex-shrink: 0;\n}\n\n.hint-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.hint-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #cbd5e1;\n}\n\n.hint-sub {\n  font-size: 11px;\n  color: #475569;\n}\n\n/* Advanced Filters Bar */\n.search-filters-bar {\n  padding: 12px 18px;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n  overflow: hidden;\n}\n\n.filters-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.filter-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.filter-item label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-item select, .filter-item input[type=\"date\"] {\n  background: #1e1f22;\n  border: 1px solid rgba(255,255,255,0.07);\n  border-radius: 6px;\n  color: #cbd5e1;\n  padding: 6px 10px;\n  font-size: 13px;\n  outline: none;\n  cursor: pointer;\n  min-width: 140px;\n  transition: border-color 0.2s;\n}\n\n.filter-item select:focus, .filter-item input[type=\"date\"]:focus {\n  border-color: var(--brand-primary, #b91c1c);\n}\n\n.filter-checkbox label {\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  text-transform: none;\n  letter-spacing: 0;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 6px 0;\n  font-weight: 500;\n}\n\n.clear-filters {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: none;\n  border: none;\n  color: #f87171;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.clear-filters:hover { text-decoration: underline; }\n\n/* Results Area */\n.search-results-area {\n  flex: 1;\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n\n.search-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px;\n  gap: 12px;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.search-spinner {\n  width: 28px;\n  height: 28px;\n  border: 2px solid rgba(185,28,28,0.2);\n  border-top-color: var(--brand-primary, #b91c1c);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.search-results-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 18px;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n}\n\n.results-count {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.results-count em {\n  color: #94a3b8;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.search-pagination {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.search-pagination button {\n  background: rgba(255,255,255,0.04);\n  border: 1px solid rgba(255,255,255,0.07);\n  color: #94a3b8;\n  border-radius: 5px;\n  padding: 3px 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: all 0.15s;\n}\n\n.search-pagination button:hover:not(:disabled) {\n  background: rgba(185,28,28,0.15);\n  border-color: var(--brand-primary, #b91c1c);\n  color: var(--brand-primary);\n}\n\n.search-pagination button:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.search-pagination span {\n  font-size: 12px;\n  color: #64748b;\n  min-width: 45px;\n  text-align: center;\n}\n\n.search-results-list {\n  padding: 8px 0;\n}\n\n.search-result-item {\n  padding: 10px 18px;\n  cursor: pointer;\n  border-radius: 0;\n  transition: background 0.15s;\n  border-bottom: 1px solid rgba(255,255,255,0.03);\n}\n\n.result-channel-info {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: #475569;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.result-channel-info svg { color: #374151; }\n\n.result-date {\n  margin-left: auto;\n  font-size: 10px;\n  color: #374151;\n  font-weight: 400;\n}\n\n.result-body {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  position: relative;\n}\n\n.result-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.result-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.result-avatar-letter {\n  width: 100%;\n  height: 100%;\n  background: var(--brand-primary, #b91c1c);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  color: white;\n}\n\n.result-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.result-author {\n  font-size: 13px;\n  font-weight: 700;\n  color: #f2f3f5;\n  margin-right: 8px;\n}\n\n.result-text {\n  font-size: 14px;\n  color: #94a3b8;\n  line-height: 1.5;\n  margin: 2px 0 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.search-highlight {\n  background: rgba(253,224,71,0.25);\n  color: #fde047;\n  border-radius: 3px;\n  padding: 0 1px;\n  font-weight: 600;\n}\n\n.result-attachment-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: #64748b;\n  background: rgba(255,255,255,0.04);\n  border-radius: 4px;\n  padding: 2px 6px;\n  margin-top: 4px;\n}\n\n.result-jump-hint {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 11px;\n  color: #374151;\n  font-weight: 600;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.search-result-item:hover .result-jump-hint { opacity: 1; color: var(--brand-primary, #b91c1c); }\n\n/* Idle & Empty States */\n.search-idle, .no-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #475569;\n  gap: 10px;\n  text-align: center;\n}\n\n.search-idle p, .no-results p {\n  font-size: 15px;\n  color: #64748b;\n  font-weight: 500;\n  margin: 0;\n}\n\n.no-results span {\n  font-size: 13px;\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
